import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import EnableSwitch from "./EnableSwitch";

const goalsColumn = [
  { id: "name", label: "SUB CATEGORY NAME", width: "95%" },
  { id: "enable", label: "ENABLE", width: "5%" },
  // { id: "category_actions", label: "ACTIONS", width: "15%" },
];

const SubCategory = ({ subCategory, index, open }) => {
  return (
    <TableRow key={index} sx={{ border: "none !important" }}>
      <TableCell
        sx={{
          width: "100%",
          padding: "0 !important",
          paddingLeft: "20px !important",
          border: "none !important",
        }}
        colSpan={3}
      >
        <Box
          sx={{ width: "100%" }}
          className={open ? "sub-c open-sub-c" : "sub-c"}
        >
          <Table
            aria-label="leads table"
            id="leadsTable"
            className="display responsive nowrap"
            style={{ width: "100%", minWidth: "700px" }}
          >
            <TableHead className="table_Head">
              <TableRow key="tb_head_tournament">
                {goalsColumn.map((column) =>
                  column.id !== "category_select" ? (
                    <TableCell key={column.id} sx={{ width: column.width }}>
                      {column.label}
                    </TableCell>
                  ) : null
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(subCategory) && subCategory.length > 0 ? (
                subCategory.map((value, index) => (
                  <>
                    <TableRow key={`sub-c-row-${index}`}>
                      <TableCell>
                        <Box className="property_name">
                          <Box className="td-wrapper">
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text"
                            >
                              {value?.name}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            <EnableSwitch
                              value={value}
                              api={`goal-sub-categories`}
                            />
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </>
                ))
              ) : subCategory !== "NO Data" ? (
                "loading..."
              ) : (
                // Array.from({ length: 10 }).map((_e, i) => (
                // <BannerSkeleton key={i} />
                // ))
                <TableRow component={`tr`}>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    {subCategory}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default SubCategory;
